module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_06_770_280_zh-hant-e6396e17990e5b286b9663eecfa5c1a2.jpg";